// extracted by mini-css-extract-plugin
export default {"spanText":"DropPlaceholder_spanText__VM+IZ"};